module.exports = __webpack_public_path__ + "img/API.7d860934.svg";